module.exports = __webpack_public_path__ + "static/img/1_doll_green.d08f73eb.png";